var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wash-summary-screen"}},[_c('div',{staticClass:"main-text"},[_c('summary-main-text',{attrs:{"moving":0,"partner":undefined}})],1),(!_vm.loadingData)?_c('div',{staticClass:"readed-qr-codes"},[_c('div',{staticClass:"qr-title"},[_vm._v(" "+_vm._s(_vm.$t("summaryScreen.qrItem.title"))+" ")]),(_vm.readedBoxesInfo.types)?_c('div',{staticClass:"type-count"},[_c('div',{staticClass:"type-a",domProps:{"innerHTML":_vm._s(
          _vm.$t('storeScreen.boxTypes.typeA', {
            count: _vm.readedBoxesInfo.types['0']
          })
        )}}),_c('div',{staticClass:"type-b",domProps:{"innerHTML":_vm._s(
          _vm.$t('storeScreen.boxTypes.typeB', {
            count: _vm.readedBoxesInfo.types['1']
          })
        )}}),_c('div',{staticClass:"type-c",domProps:{"innerHTML":_vm._s(
          _vm.$t('storeScreen.boxTypes.typeC', {
            count: _vm.readedBoxesInfo.types['2']
          })
        )}})]):_vm._e(),_c('div',{staticClass:"divider"}),_c('div',{staticClass:"readed-boxes"},[_c('ul',_vm._l((this.readedBoxesInfo.readedBoxes),function(item,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(
            _vm.$t('summaryScreen.qrItem', {
              code: item.code,
              type: _vm.$variables.boxTypes[item.type],
              qrCode: item.QRNumber
            })
          )}})}),0),(_vm.readedBoxesInfo.notFoundBoxes.length > 0)?[_c('div',{staticClass:"not-found-qr-title"},[_vm._v(" "+_vm._s(_vm.$t("summaryScreen.notFoundQRItem.title"))+" ")]),_c('ul',{staticClass:"not-found-boxes-list"},_vm._l((this.readedBoxesInfo.notFoundBoxes),function(item,index){return _c('li',{key:index,domProps:{"innerHTML":_vm._s(
              _vm.$t('summaryScreen.notFoundQRItem', {
                qrCode: item
              })
            )}})}),0)]:_vm._e()],2)]):[_c('div',{staticClass:"loading-screen"},[_c('loader-ring')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }